const localHosts = new Set(["localhost", "127.0.0.1"]);

export const apiOrigin = localHosts.has(window.location.hostname)
  ? "http://localhost:3000"
  : "https://prod.singtico.com";

export const v1BaseUrl = `${apiOrigin}/v1/`;
